import { useContext } from 'react';
import { ModalContext } from '../hocs/modal-context';

export const useModal = () => useContext(ModalContext);
